import React from 'react';
import { Navigate } from 'react-router-dom';

const RedirectWithStatus = ({ to }) => (
  <Navigate to={to} replace />
);

export default RedirectWithStatus;
